module.exports = __webpack_public_path__ + "img/android.7420a9b1.webp";